import { render, staticRenderFns } from "./ImageonTemplate.vue?vue&type=template&id=65b33619&scoped=true&"
import script from "./ImageonTemplate.vue?vue&type=script&lang=js&"
export * from "./ImageonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ImageonTemplate.vue?vue&type=style&index=0&id=65b33619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b33619",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VPagination,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b33619')) {
      api.createRecord('65b33619', component.options)
    } else {
      api.reload('65b33619', component.options)
    }
    module.hot.accept("./ImageonTemplate.vue?vue&type=template&id=65b33619&scoped=true&", function () {
      api.rerender('65b33619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Template/ImageonTemplate.vue"
export default component.exports